//	https://tgomilar.github.io/paroller.js/#usage
function fnInViewDetect( ) {

	// Run
	fnApplyClasses();

	// Re-run on-scroll
	$( window ).scroll( function() {
		fnApplyClasses();
	});

	function fnApplyClasses() {

		//	When in view
		$( 'main.base > section' ).removeClass( 'in-view' );
		$( 'main.base > section:in-viewport' ).addClass( 'in-view' );

		$( 'main.base > header' ).removeClass( 'in-view' );
		$( 'main.base > header:in-viewport' ).addClass( 'in-view' );

		$( '.view-detect' ).removeClass( 'in-view' );
		$( '.view-detect:in-viewport' ).addClass( 'in-view' );

		//	If viewed at least once
		$( 'main.base > section:in-viewport' ).addClass( 'viewed' );
		$( 'main.base > header:in-viewport' ).addClass( 'viewed' );
		$( '.view-detect:in-viewport' ).addClass( 'viewed' );

	}

}
